<template>
  <div class="content-item">
    <h2 class="heading">Social Media Links (Optional)</h2>
    <p class="text">This will be listed on the card</p>
    <div class="form-group">
      <textarea class="form-textarea" v-model="social_media"></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step9',
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      social_media: '',
    };
  },
  methods: {
    submit() {
      this.$emit('input', {
        ...this.value,
        social_media: this.social_media,
      });
    },
  },
};
</script>
